/* __next_internal_client_entry_do_not_use__ FilterInfoSticky auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { handleKeyDown } from "@faire/retailer-visitor-shared/lib/handleKeyDown";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Button } from "@faire/web--source/slate/Button";
import { Pill } from "@faire/web--source/slate/Filter/styled";
import { Filter as FilterIcon } from "@faire/web--source/slate/icons/foundation/Filter";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { trackRetailersFilterInteraction } from "@faire/web-api--source/events/retailers/actionUnknown/filterInteraction";
import { trackRetailersFilterClearClick } from "@faire/web-api--source/events/retailers/click/filterClear";
import React, { useRef, useState } from "react";
import styled, { css } from "styled-components";
import { MaybeDraggableStickyRowForDiscoverPage } from "@faire/retailer/components/Filters/MaybeDraggableStickyRowForDiscoverPage";
import { ToggleFilterRow } from "@faire/retailer/components/Filters/ToggleFilterRow";
import { ToggleSidebarFiltersPill } from "@faire/retailer/components/Filters/ToggleSidebarFiltersPill";
import { useFilterScrollToProducts } from "@faire/retailer/components/Filters/useFilterScrollToProducts";
import { Header, Sort } from "./Sort";
export var FilterInfoSticky = function(param) {
    var name = param.name, className = param.className, isLoading = param.isLoading, _param_Wrapper = param.Wrapper, Wrapper = _param_Wrapper === void 0 ? React.Fragment : _param_Wrapper, _param_shouldNotShowFilterCollapsePillOnTabletAndBelow = param.shouldNotShowFilterCollapsePillOnTabletAndBelow, shouldNotShowFilterCollapsePillOnTabletAndBelow = _param_shouldNotShowFilterCollapsePillOnTabletAndBelow === void 0 ? false : _param_shouldNotShowFilterCollapsePillOnTabletAndBelow, shouldShowSort = param.shouldShowSort, _param_shouldEnableScrollToProducts = param.shouldEnableScrollToProducts, shouldEnableScrollToProducts = _param_shouldEnableScrollToProducts === void 0 ? false : _param_shouldEnableScrollToProducts;
    var isSSR = useIsSSR();
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useFilterStore = useFilterStore([
        "activeFilterCount",
        "shouldShowFilterCollapsePill",
        "filterSections"
    ]), _useFilterStore_data = _useFilterStore.data, activeFilterCount = _useFilterStore_data.activeFilterCount, shouldShowFilterCollapsePill = _useFilterStore_data.shouldShowFilterCollapsePill, filterSections = _useFilterStore_data.filterSections, setFilterState = _useFilterStore.setFilterState, clearAllFilters = _useFilterStore.clearAllFilters;
    var scrollRef = useRef(null);
    useFilterScrollToProducts(scrollRef, !isLoading, shouldEnableScrollToProducts);
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var _useState = _sliced_to_array(useState(false), 2), isDragging = _useState[0], setIsDragging = _useState[1];
    var hasFilterSelected = activeFilterCount > 0;
    var onMobileAllFilterIconClick = function() {
        trackRetailersFilterInteraction(name, "open_filters", "modal");
        setFilterState(function(currentState) {
            return _object_spread_props(_object_spread({}, currentState), {
                isMobileModalOpen: true,
                isNewFilterSelected: false
            });
        });
    };
    var handleClearFilters = function() {
        if (activeFilterCount > 0) {
            trackRetailersFilterClearClick(name, "mobile_clear_all", "");
            clearAllFilters();
        }
    };
    if (isLoading === false && filterSections.length === 0 || isSSR) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            shouldEnableScrollToProducts ? /*#__PURE__*/ _jsx("div", {
                ref: scrollRef
            }) : null,
            /*#__PURE__*/ _jsxs(MaybeDraggableStickyRowForDiscoverPage, {
                className: className,
                isLoading: isLoading,
                setIsDragging: setIsDragging,
                overflowVisible: shouldShowSort,
                children: [
                    /*#__PURE__*/ _jsxs(Wrapper, {
                        children: [
                            shouldShowFilterCollapsePill ? /*#__PURE__*/ _jsx(MaybeToggleSidebarFiltersPill, {
                                shouldNotShowOnTabletAndBelow: shouldNotShowFilterCollapsePillOnTabletAndBelow
                            }) : null,
                            /*#__PURE__*/ _jsxs(MobileButtonsContainer, {
                                children: [
                                    hasFilterSelected ? /*#__PURE__*/ _jsx(StyledClearButton, {
                                        variant: "tertiary",
                                        onClick: handleClearFilters,
                                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                            id: "M+I5uz",
                                            defaultMessage: [
                                                {
                                                    type: 0,
                                                    value: "Clear all"
                                                }
                                            ]
                                        })
                                    }) : null,
                                    activeFilterCount > -1 ? /*#__PURE__*/ _jsxs(StyledPill, {
                                        isOpen: false,
                                        alwaysShowCloseButton: hasFilterSelected,
                                        hasFilterSelected: true,
                                        onClick: onMobileAllFilterIconClick,
                                        role: "button",
                                        "data-test-id": "open-filters-modal-button",
                                        "aria-label": strictLocalize({
                                            id: "bA3RRW",
                                            defaultMessage: [
                                                {
                                                    type: 0,
                                                    value: "Open filters modal"
                                                }
                                            ]
                                        }),
                                        tabIndex: 0,
                                        onKeyDown: handleKeyDown(onMobileAllFilterIconClick),
                                        children: [
                                            /*#__PURE__*/ _jsx(Spacer, {
                                                width: 4
                                            }),
                                            /*#__PURE__*/ _jsx(Typography, {
                                                style: {
                                                    width: "max-content"
                                                },
                                                children: hasFilterSelected ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                    id: "JnXG/8",
                                                    defaultMessage: [
                                                        {
                                                            type: 0,
                                                            value: "Filters ("
                                                        },
                                                        {
                                                            type: 1,
                                                            value: "activeFilterNumber"
                                                        },
                                                        {
                                                            type: 0,
                                                            value: ")"
                                                        }
                                                    ],
                                                    values: {
                                                        activeFilterNumber: activeFilterCount
                                                    }
                                                }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                    id: "GBuerY",
                                                    defaultMessage: [
                                                        {
                                                            type: 0,
                                                            value: "All filters"
                                                        }
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Spacer, {
                                                width: 4
                                            }),
                                            /*#__PURE__*/ _jsx(FilterIcon, {
                                                fontSize: "24px"
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        width: "1x"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(StyledToggleFilterRow, {
                                name: name,
                                $useUpdatedSpacing: isLoggedInRetailer,
                                $isDragging: isDragging,
                                $addPaddingRight: shouldShowSort,
                                shouldShowButtons: shouldShowSort
                            })
                        ]
                    }),
                    shouldShowSort ? /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                        desktopAndAbove: /*#__PURE__*/ _jsx(StyledSort, {
                            name: name,
                            roundCorners: true
                        })
                    }) : null
                ]
            })
        ]
    });
};
var StyledSort = styled(Sort).withConfig({
    componentId: "sc-5155471a-0"
})([
    "margin-left:auto;padding-top:",
    ";padding-bottom:",
    ";",
    "{&:hover{border-color:",
    ";}}"
], getSpacing("1x"), getSpacing("1x"), Header, Core.border.default);
var StyledToggleFilterRow = styled(ToggleFilterRow).withConfig({
    componentId: "sc-5155471a-1"
})([
    "",
    " padding:",
    ";",
    " &:empty{display:none;}",
    "{padding:",
    ";}"
], function(param) {
    var $isDragging = param.$isDragging;
    return $isDragging ? css([
        "user-select:none;pointer-events:none;"
    ]) : null;
}, getSpacing("1x", 0), function(param) {
    var $addPaddingRight = param.$addPaddingRight;
    return $addPaddingRight ? css([
        "padding-right:",
        ";"
    ], getSpacing("1x")) : null;
}, responsiveMediaQueries.mobile, function(param) {
    var $useUpdatedSpacing = param.$useUpdatedSpacing;
    return $useUpdatedSpacing ? getSpacing("1x", 0) : undefined;
});
var StyledClearButton = styled(Button).withConfig({
    componentId: "sc-5155471a-2"
})([
    "margin-right:",
    ";min-width:max-content;"
], getSpacing("2x"));
var StyledPill = styled(Pill).withConfig({
    componentId: "sc-5155471a-3"
})([
    "padding:",
    ";background-color:",
    ";border:1px solid ",
    ";&:hover{border-color:",
    ";}"
], getSpacing(0, 10), Core.surface.inverse, Core.border.muted, Core.border.default);
// eslint-disable-next-line @faire/prefer-slate-attrs -- use ResponsiveContentV2
var MobileButtonsContainer = styled(Row).withConfig({
    componentId: "sc-5155471a-4"
})([
    "min-width:max-content;padding:",
    ";&&&{",
    "{display:none;}}"
], getSpacing("1x", 0), responsiveMediaQueries.desktopAndAbove);
var MaybeToggleSidebarFiltersPill = function(param) {
    var shouldNotShowOnTabletAndBelow = param.shouldNotShowOnTabletAndBelow;
    return shouldNotShowOnTabletAndBelow ? /*#__PURE__*/ _jsx(ResponsiveContentV2, {
        noJS: true,
        desktopAndAbove: /*#__PURE__*/ _jsx(ToggleSidebarFiltersPill, {})
    }) : /*#__PURE__*/ _jsx(ToggleSidebarFiltersPill, {});
};
